<div
  class="priority-badge"
  [pTooltip]="wpPriority.name"
  [ngClass]="labelClasses"
  [tooltipDisabled]="(showLabel && wpPriority.name.length < 8) || !showTooltip">
  <svg-icon
    size="md"
    [ngStyle]="{ color: wpPriority.color }"
    [key]="castIcon | call: wpPriority.icon ?? defaultIcon">
  </svg-icon>

  <span
    *ngIf="showLabel"
    class="text"
    [ngStyle]="{ color: wpPriority.color }">
    {{ wpPriority.name }}
  </span>
</div>
